import React from "react";
import "./TypingIndicator.css";

export enum TypingIndicatorVariant {
  Normal,
  Small,
}

export const TypingIndicator = (props: {
  variant?: TypingIndicatorVariant;
}) => {
  const { variant } = props;

  return (
    <div
      className={`typing-indicator bg-app-sand ${
        variant === TypingIndicatorVariant.Small ? "small" : ""
      }`}
    >
      <div className="typing-dot bg-app-sand-dark"></div>
      <div className="typing-dot bg-app-sand-dark"></div>
      <div className="typing-dot bg-app-sand-dark"></div>
    </div>
  );
};
